import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';

// styles
import {
  ColContactInfoStyled,
  LinkContactStyled,
  RowStyled,
} from './styles';

export default () => (
  <SectionContainer
    id='anti-fraud-efforts-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <RowStyled align='center'>
      <Col>
        <Typography
          component='h1'
          align='center'
          nextElement='link'>
          Anti&#45;Fraud Efforts
        </Typography>
        <Typography nextElement='link'>
          <Link
            id='anti-fraud-efforts-insurance-fraud-link'
            variant='primaryDeemphasize'
            linkUrl='#anti-fraud-efforts-insurance-fraud-section-container'
            ariaLabel='Navigate to insurance fraud section.'>
            Insurance Fraud
          </Link>
        </Typography>
        <Typography disableBottomPadding>
          <Link
            id='anti-fraud-efforts-email-hacking-fraud-link'
            variant='primaryDeemphasize'
            linkUrl='#anti-fraud-efforts-email-hacking-fraud-section-container'
            ariaLabel='Navigate to email hacking fraud section.'>
            Email Hacking Fraud
          </Link>
        </Typography>
      </Col>
    </RowStyled>
    <Row align='center'>
      <Col>
        <Typography
          component='h2'
          disableBottomPadding>
          What to do if:
        </Typography>
      </Col>
    </Row>
    <RowStyled align='center'>
      <Col medium={6}>
        <BulletedList
          disableBottomPadding
          bulletedListData={[
            { bulletText: 'You suspect that an unauthorized person has accessed your Northwestern Mutual accounts or products.' },
            { bulletText: 'You suspect you have been the victim of fraud via identity theft, email hacking, compromised passwords, etc.' },
            { bulletText: (<>You suspect fraud has been occurring or has been committed against Northwestern Mutual or Northwestern Mutual Long&#45;Term Care Insurance Company.</>) },
            { bulletText: 'You suspect someone is attempting to take advantage of a Northwestern Mutual client by accessing their funds or accounts held at Northwestern Mutual. This is a particular concern for clients who are elderly or have diminished capacity.' },
          ]} />
      </Col>
      <ColContactInfoStyled
        medium={6}
        align='center'>
        <Typography variant='h4'>
          Contact the Special Investigations Unit (SIU)
        </Typography>
        <Typography disableBottomPadding>
          Call:
        </Typography>
        <LinkContactStyled
          id='anti-fraud-efforts-special-investigations-unit-phone-link-1'
          linkUrl='tel:8776072485'
          ariaLabel='Call anti fraud Special Investigations Unit at northwestern mutual.'
          variant='primaryDeemphasize'>
          877&#45;607&#45;2485
        </LinkContactStyled>
        <Typography disableBottomPadding>
          Email:
        </Typography>
        <LinkContactStyled
          id='anti-fraud-efforts-special-investigations-unit-email-link-1'
          variant='primaryDeemphasize'
          linkUrl='mailto:antifraud&#64;northwesternmutual.com'
          ariaLabel='Email anti fraud at northwestern mutual dot com.'>
          antifraud&#64;northwesternmutual.com
        </LinkContactStyled>
      </ColContactInfoStyled>
    </RowStyled>
    <Row align='center'>
      <Col>
        <Typography
          component='h2'
          disableBottomPadding>
          What to do if:
        </Typography>
      </Col>
    </Row>
    <RowStyled align='center'>
      <Col medium={6}>
        <BulletedList
          disableBottomPadding
          bulletedListData={[
            { bulletText: (<>You suspect that your non&#45;Northwestern Mutual personal information or passwords have been compromised.</>) },
          ]} />
      </Col>
      <ColContactInfoStyled
        medium={6}
        align='center'>
        <Typography variant='h4'>
          Contact the SIU if you are concerned that someone will use your personal information or passwords to access your Northwestern Mutual accounts or Northwestern Mutual products.
        </Typography>
        <Typography disableBottomPadding>
          Call:
        </Typography>
        <LinkContactStyled
          id='anti-fraud-efforts-special-investigations-unit-phone-link-2'
          linkUrl='tel:8776072485'
          ariaLabel='Call the anti fraud Special Investigations Unit at northwestern mutual concerning compromized passwords or personal information.'
          variant='primaryDeemphasize'>
          877&#45;607&#45;2485
        </LinkContactStyled>
        <Typography disableBottomPadding>
          Email:
        </Typography>
        <LinkContactStyled
          id='anti-fraud-efforts-special-investigations-unit-email-link-2'
          variant='primaryDeemphasize'
          linkUrl='mailto:antifraud&#64;northwesternmutual.com'
          ariaLabel='Email anti fraud at northwestern mutual concerning compromized passwords or personal information.'>
          antifraud&#64;northwesternmutual.com
        </LinkContactStyled>
        <Typography disableBottomPadding>
          Otherwise, consider the Hacked Email Account Concerns and Identity Theft Guidelines below.
        </Typography>
      </ColContactInfoStyled>
    </RowStyled>
    <Row>
      <Col medium={8}>
        <Typography component='h3'>
          When contacting the SIU, please provide the following information, if possible:
        </Typography>
        <BulletedList
          disableBottomPadding
          bulletedListData={[
            { bulletText: 'Your name' },
            { bulletText: 'Contact information' },
            { bulletText: 'Policy or product numbers' },
            { bulletText: 'Details of the suspected fraud' },
          ]} />
      </Col>
    </Row>
  </SectionContainer>
);
